import React from 'react'
import Signin from '../Components/Signin/Signin'

const SigninView = () => {
  return (
    <div>
        <Signin />
    </div>
  )
}

export default SigninView